export default {
    namespaced: true,
    state: {
        data: null,
        shown: false,
    },
    mutations: {
        SHOW_CONFIRM(state, payload) {
            state.data = payload;
            state.shown = true;
        },
        SHOW_MESSAGE(state, payload) {
            state.data = payload;
            state.shown = true;
        },
        CLOSE_DIALOG(state) {
            state.data = null;
            state.shown = false;
        },
        IS_SHOWN(state, payload){
            state.shown = payload;
        },
    },
    actions: {
        showConfirm({ commit }, payload) {
            commit("SHOW_CONFIRM", payload);
        },
        showMessage({ commit }, payload) {
            commit("SHOW_MESSAGE", payload);
        },
        async closeDialog({ commit }) {
            commit("CLOSE_DIALOG");
        },
        dialogIsShown({ commit }, payload){
            commit("IS_SHOWN", payload);
        },
    },
};